module.exports = __webpack_public_path__ + "img/4.1162e82d.png";